
import { useSelector} from 'react-redux';
import Navigation from '../Navigation';
import AuthNav from '../AuthNav';
import UserMenu from '../UserMenu';
import s from './AppBar.module.css';
import { authSelectors } from '../../redux/auth';


export default function AppBar() {
  const isAuthenticated = useSelector(authSelectors.getIsAuthenticated);

  return (
    <header className={s.Header}>
      <Navigation />
     {isAuthenticated ? <UserMenu/> : <AuthNav/>} 
    </header>
  )
};





